export class EntLivestockTradeActivityFilter {
  page: number;
  size: number;
  deleted: boolean;
  year?: number;
  citizenshipId?: number;
  productTypeIds?: number[];
  operationType?: string;
  unitMeasurementIds?: number[];
  hsCode?: string;

  constructor(init?: Partial<EntLivestockTradeActivityFilter>) {
	this.page = 1;
	this.size = 30;
	this.deleted = false;
	if (init) {
	  Object.assign(this, init)
	}
  }
}